export enum LANGUAGES {
  PL = "pl",
  EN = "en",
}
